import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Users, Leaf, Sparkles, HeartPulse, Clock } from 'lucide-react';
const authorityItems = [{
  icon: Leaf,
  label: 'Protocolo Natural'
}, {
  icon: Sparkles,
  label: 'Sin Suplementos Caros'
}, {
  icon: HeartPulse,
  label: 'Resultados en 21 Días'
}];
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-36 md:pb-28 overflow-hidden bg-cream" data-id="element-75">
      {/* Soft organic background blobs */}
      <div aria-hidden className="absolute -top-20 -right-24 w-[28rem] h-[28rem] rounded-full bg-salvia/20 blur-3xl pointer-events-none" data-id="element-76" />
      <div aria-hidden className="absolute -bottom-32 -left-20 w-[26rem] h-[26rem] rounded-full bg-olive blur-3xl pointer-events-none" data-id="element-77" />

      <div className="relative container mx-auto px-5 sm:px-6 max-w-6xl" data-id="element-78">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-20" data-id="element-79">
          {/* Left Content */}
          <div className="w-full md:w-1/2 flex flex-col items-start" data-id="element-80">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="w-full" data-id="element-81">
              {/* LAUNCH OFFER BADGE — flotante */}
              <motion.div animate={{
              scale: [1, 1.03, 1]
            }} transition={{
              duration: 2.4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="inline-flex items-center gap-1.5 bg-[#FFE5DC] border border-[#FF6B35]/40 text-[#C4421C] py-1.5 px-3.5 rounded-full mb-4 shadow-sm" data-id="element-82">
                <span className="text-sm leading-none" data-id="element-83">🔥</span>
                <span className="text-[11px] sm:text-xs font-black tracking-[0.18em] uppercase" data-id="element-84">
                  OFERTA DE LANZAMIENTO — 87% DTO
                </span>
              </motion.div>

              {/* HEADLINE */}
              <h1 className="font-serif text-[2.5rem] sm:text-5xl md:text-6xl lg:text-[4.25rem] font-bold tracking-tight text-forest leading-[1.02] mb-4" data-id="element-85">
                Elimina la Inflamación y recupera tu Vientre Plano en 21 días
              </h1>

              {/* Sub-headline */}
              <p className="font-sans text-base md:text-lg text-forest/75 font-medium mb-6 max-w-lg leading-snug" data-id="element-86">
                El protocolo digital diseñado para mujeres activas que buscan
                resultados reales sin complicaciones. Sin dejar de comer lo que
                amas.
              </p>

              {/* ===== PRICE BLOCK — above the fold ===== */}
              <div className="flex items-baseline gap-3 sm:gap-4 mb-2 flex-wrap" data-id="element-87">
                <span className="text-base sm:text-lg text-forest/40 font-medium line-through" data-id="element-88">
                  $49.00
                </span>
                <span className="font-serif text-[3.25rem] sm:text-6xl md:text-7xl font-black text-[#2D6A4F] tracking-[-0.04em] leading-none" data-id="element-89">
                  $6.36
                </span>
                <span className="inline-flex items-center bg-[#2D6A4F] text-white text-[10px] font-black tracking-[0.15em] uppercase px-2 py-1 rounded-full self-center" data-id="element-90">
                  -87%
                </span>
              </div>

              {/* Scarcity line with clock */}
              <p className="inline-flex items-start gap-1.5 text-xs sm:text-[13px] text-[#C4421C] font-semibold mb-2 max-w-lg leading-snug" data-id="element-91">
                <Clock className="w-3.5 h-3.5 mt-0.5 shrink-0" strokeWidth={2.5} data-id="element-92" />
                <span data-id="element-93">
                  Precio promocional disponible solo por tiempo limitado para
                  las próximas 100 descargas.
                </span>
              </p>

              <p className="text-sm text-forest/60 font-medium italic mb-6" data-id="element-94">
                Por menos de lo que cuesta un café latte en Starbucks ☕
              </p>

              {/* CTA */}
              <div className="flex flex-col items-start gap-2 w-full sm:w-auto" data-id="element-95">
                <motion.a href="https://vyralea.com/cart/55833622118740:1" whileHover={{
                scale: 1.02,
                y: -2
              }} whileTap={{
                scale: 0.98
              }} className="w-full sm:w-auto bg-[#2D6A4F] text-white px-8 sm:px-10 py-5 sm:py-6 rounded-full text-base md:text-lg font-bold tracking-tight text-center hover:bg-[#1B4332] transition-colors shadow-xl shadow-[#2D6A4F]/30" data-id="element-96">
                  ¡SÍ, QUIERO MI PROTOCOLO POR SOLO $6.36!
                </motion.a>
                <span className="text-xs text-forest/60 font-medium pl-1" data-id="element-97">
                  Descarga inmediata y segura • Pago único
                </span>
              </div>

              <div className="mt-6 flex items-center gap-5 text-xs sm:text-sm text-forest/70 font-medium" data-id="element-98">
                <div className="flex items-center gap-2" data-id="element-99">
                  <Users className="w-4 h-4 text-salvia" data-id="element-100" />
                  <span data-id="element-101">+1.200 mujeres</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-102">
                  <ShieldCheck className="w-4 h-4 text-salvia" data-id="element-103" />
                  <span data-id="element-104">Garantía 7 días</span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Right Image */}
          <div className="w-full md:w-1/2" data-id="element-105">
            <motion.div initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative w-full aspect-square rounded-[2.5rem] shadow-2xl shadow-forest/10 overflow-hidden border border-white" data-id="element-106">
              <img src="https://cdn.magicpatterns.com/uploads/4g37VQ4Ur5GNzKroJ3soHh/MOCKUP_BUENO.png" alt="Protocolo GUT LABS™ — vientre plano y digestión ligera en 21 días" className="w-full h-full object-cover" data-id="element-107" />
            </motion.div>
          </div>
        </div>

        {/* Authority Row — 3 icons */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-20 md:mt-28 pt-10 md:pt-14 border-t border-salvia/40" data-id="element-108">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4 max-w-4xl mx-auto" data-id="element-109">
            {authorityItems.map((item, i) => {
            const Icon = item.icon;
            return <div key={i} className="flex items-center justify-center gap-3 text-center" data-id="element-110">
                  <span className="w-11 h-11 rounded-full bg-salvia/20 flex items-center justify-center shrink-0" data-id="element-111">
                    <Icon className="w-5 h-5 text-forest" strokeWidth={2} data-id="element-112" />
                  </span>
                  <span className="text-sm md:text-[15px] font-bold tracking-tight text-forest uppercase" data-id="element-113">
                    {item.label}
                  </span>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}